import logo from "../assets/logo.png";

const branding = {
  logo,
  name: "Gestao de Documentos",
  tagline: "Gestao de Documentos",
};

export default branding;
